import { createState } from '../../lib/create-state';

import { BingoWinnerMessage } from '../../types/bingo-events/in/backend/winner-message';
import type { Winner } from '../../types/bingo-events/in/backend/winner-message';

export type WinnerState = BingoWinnerMessage;

export const DEFAULT_WINNER_STATE: WinnerState = {
    gameSessionId: 0,
    winners: [],
    extraWinners: [],
    consolationWinners: [],
};

export const [winners, resetWinnerMessages] = createState(DEFAULT_WINNER_STATE);
export const [ticketWins, resetTicketWins] = createState<{
    gameSessionId: number;
    records: Winner[];
    complete: boolean;
}>({ gameSessionId: 0, records: [], complete: false });

export const resetWinners = () => {
    resetWinnerMessages();
    resetTicketWins();
};
